const liaisonText = {
  heading: 'Skontaktuj się z naszym działem handlowym',
  text: 'Zapraszamy do współpracy klientów indywidualnych oraz klientów biznesowych. Realizujemy zamówienia hurtowe oraz detaliczne. Oferujemy możliwość współpracy partnerskiej w Polsce i za granicą.',
};

export { liaisonText };